<template>
    <div>
        <label>
            <input type="checkbox" v-model="value">
            {{$t('subscription.payment_legals.addon_legacy', {price})}}
        </label>
    </div>
</template>
<script>
import EventBus from "../../eventbus";
import resources from "../../resources";

export default {
    name: 'AddOnLegacy',
    data() {
        return {
            value: true,
            price: null,
        }
    },
    mounted(){
        this.loadAddon();
        // setTimeout(_=>this.emitChange(), 500);
    },
    methods: {
        loadAddon(){
            resources.addons.index({})
                .then((resp) => {
                    this.price = resp.data.data.amount;
                    this.emitChange();
                }).catch(err => {

                });
        },
        emitChange(){
            EventBus.$emit('addon_legacy', this.value);
        }
    },
    watch:{
        value(){
            this.emitChange();
        },
    },
}
</script>
<style scoped lang="scss">
@import '../../styles/variables';
@import '../../styles/classes';
label{
    font-size: 1.1em;
}
</style>